import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFigma20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconFigma20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.347 7.494A3 3 0 0 1 5 4.99C5 3.338 6.326 2 7.962 2h5.076C14.674 2 16 3.338 16 4.989a2.99 2.99 0 0 1-1.347 2.505A3 3 0 0 1 16 10c0 1.65-1.326 2.989-2.962 2.989h-.054a2.94 2.94 0 0 1-2.005-.79v2.785A3.014 3.014 0 0 1 7.976 18 2.987 2.987 0 0 1 5 15.011c0-1.049.536-1.972 1.347-2.505A2.99 2.99 0 0 1 5 10c0-1.05.536-1.973 1.347-2.506M10.98 10c0 1.117.897 2.023 2.005 2.023h.054A2.014 2.014 0 0 0 15.043 10a2.014 2.014 0 0 0-2.005-2.023h-.054A2.014 2.014 0 0 0 10.979 10m-.958-2.023H7.962A2.014 2.014 0 0 0 5.957 10c0 1.115.894 2.02 1.999 2.023h2.065zM7.962 12.99h-.006a2.014 2.014 0 0 0-1.999 2.022c0 1.114.908 2.023 2.019 2.023a2.053 2.053 0 0 0 2.045-2.05V12.99zm2.06-5.978h-2.06A2.014 2.014 0 0 1 5.957 4.99c0-1.118.898-2.023 2.005-2.023h2.06zm3.016 0h-2.06V2.966h2.06c1.107 0 2.005.905 2.005 2.023a2.014 2.014 0 0 1-2.005 2.022"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFigma20);
